export const COUNTRIES = [
  'India', 'United States', 'United Kingdom', 'United Arab Emirates', 'Australia', 'Canada',
  'Singapore', 'Germany', 'France', 'Netherlands', 'Switzerland', 'Japan', 'China', 'Hong Kong',
  'South Korea', 'Saudi Arabia', 'Qatar', 'Kuwait', 'Bahrain', 'Oman', 'Israel', 'Turkey',
  'Russia', 'Brazil', 'Mexico', 'Argentina', 'Chile', 'Colombia', 'Peru', 'South Africa',
  'Nigeria', 'Kenya', 'Egypt', 'Morocco', 'Indonesia', 'Malaysia', 'Thailand', 'Philippines',
  'Vietnam', 'Pakistan', 'Bangladesh', 'Sri Lanka', 'Nepal', 'Bhutan', 'Afghanistan', 'Italy',
  'Spain', 'Portugal', 'Belgium', 'Austria', 'Sweden', 'Norway', 'Denmark', 'Finland', 'Ireland',
  'Poland', 'Czech Republic', 'Hungary', 'Romania', 'Greece', 'Ukraine', 'New Zealand', 'Iceland',
  'Luxembourg', 'Monaco', 'Cyprus', 'Malta', 'Jordan', 'Lebanon', 'Iraq', 'Iran', 'Kazakhstan',
  'Uzbekistan', 'Georgia', 'Armenia', 'Azerbaijan', 'Mongolia', 'Myanmar', 'Cambodia', 'Laos',
  'Taiwan', 'Brunei', 'Fiji', 'Papua New Guinea', 'Ghana', 'Ethiopia', 'Tanzania', 'Uganda',
  'Rwanda', 'Zambia', 'Zimbabwe', 'Botswana', 'Namibia', 'Mauritius', 'Seychelles', 'Algeria',
  'Tunisia', 'Libya', 'Sudan', 'Cuba', 'Jamaica', 'Trinidad and Tobago', 'Bahamas', 'Panama',
  'Costa Rica', 'Guatemala', 'Ecuador', 'Bolivia', 'Paraguay', 'Uruguay', 'Venezuela',
  'Dominican Republic', 'Haiti', 'Croatia', 'Serbia', 'Slovenia', 'Slovakia', 'Bulgaria',
  'Bosnia and Herzegovina', 'Albania', 'North Macedonia', 'Estonia', 'Latvia', 'Lithuania',
  'Moldova', 'Belarus', 'Maldives', 'Other',
].sort((a, b) => (a === 'India' ? -1 : b === 'India' ? 1 : a.localeCompare(b)));

export const INDIAN_STATES = [
  'Andhra Pradesh', 'Arunachal Pradesh', 'Assam', 'Bihar', 'Chhattisgarh', 'Goa', 'Gujarat',
  'Haryana', 'Himachal Pradesh', 'Jharkhand', 'Karnataka', 'Kerala', 'Madhya Pradesh',
  'Maharashtra', 'Manipur', 'Meghalaya', 'Mizoram', 'Nagaland', 'Odisha', 'Punjab', 'Rajasthan',
  'Sikkim', 'Tamil Nadu', 'Telangana', 'Tripura', 'Uttar Pradesh', 'Uttarakhand', 'West Bengal',
  'Andaman and Nicobar Islands', 'Chandigarh', 'Dadra and Nagar Haveli and Daman and Diu',
  'Delhi (NCT)', 'Jammu and Kashmir', 'Ladakh', 'Lakshadweep', 'Puducherry',
];
